import { useFormikContext } from "formik";
import { useEffect } from "react";

export const FormObserver = ({ onChange }) => {
  const { values, dirty } = useFormikContext();

  useEffect(() => {
    if (onChange) {
      onChange(values, dirty);
    }
  }, [values, dirty, onChange]);

  return null;
};
